
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    Paper,
    Chip
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailRecipientModel,
        EmailTemplateModel,
        EmailContextObjectModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import {validateEmailField} from '../../utils/fieldValidations';
import {LookupDialogComponent} from "../fields/LookupDialog";
import {EmailContextObjectComponent} from "./EmailContextObject";

export const EmailTemplateComponent: React.FC<{
  emailTemplate: EmailTemplateModel | null,
  onChange: (selectedUuid: string) => void
}> = ({
  emailTemplate,
  onChange
}) => {

  const styles = ContainerClasses();

  const [openLookupDialog, setOpenLookupDialog] = useState<boolean>(false);

  const handleSearch = () => {
    setOpenLookupDialog(!openLookupDialog);
  }

  const handleChange = (selectedRecord: RecordModel | null) => {
    if(selectedRecord){
      onChange(selectedRecord.fields.Uuid_sys.fieldValue)
    }
    setOpenLookupDialog(!openLookupDialog);
  }


  return (

    <>
    <LookupDialogComponent
      objectApiName={"EmailTemplate_c"}
      openDialog={openLookupDialog}
      onCloseDialog={() => {
        setOpenLookupDialog(false);
          }}
      onSelect={handleChange}
    />

   <Box sx={{...styles.containerRowB,
             pt: '1rem',
             pl: '1rem',
             pr: '1rem',
             gap: '1rem'}}>

     <Typography
        variant="subtitle1"
      >
       Use Template:
     </Typography>

     <TextField
        fullWidth
        disabled
        required={false}
        size="small"
        label="Email Template"
        variant="filled"
        value={emailTemplate?.Label_c ?? ""}
        inputProps={{
          maxLength: 255,
          onClick: () => console.log("field clicked")
        }}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <InputAdornment position="end">
               <IconButton size="small" onClick={() => handleSearch()}>
                  <SearchIcon />
              </IconButton>
          </InputAdornment>
          )
        }}
      />
    </Box>

    {emailTemplate &&
    <Box sx={{
          display: "flex",
          gap: "1rem",
          alignItems: 'center',
          pt: '1rem',
          pl: '1rem',
          pr: '1rem'
        }}
     >
     <Typography variant="subtitle1">
       Context Objects:
     </Typography>
     <Box  sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.5rem",
          alignItems: 'center'
        }}
        >

      {emailTemplate.contextObjects.map((contextObject: EmailContextObjectModel) => {
          return (
            <EmailContextObjectComponent
              key={contextObject.Uuid_sys}
              contextObject = {contextObject}
              onChange = {(selectedRecord: RecordModel) => {contextObject.setReferencedRecord(selectedRecord)}}
            />
          )}
       )}
       </Box>
    </Box>
    }

    </>
    )
};
